<template>
    <div>
        <div class="banner">
            <div class="swiper-wrapper">
                <div class="swiper-slide"><img src="@/assets/goyb02.png" alt="" /></div>
                <div class="swiper-slide"><img src="@/assets/goyb03.png" alt="" /></div>
                <div class="swiper-slide"><img src="@/assets/goyb01.png" alt="" /></div>
            </div>
            <!-- 如果需要分页器 -->
            <!-- <div class="swiper-pagination"></div> -->

            <!-- 如果需要导航按钮 -->
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
        </div>
        <!-- <div class="main1">
            <div class="title1">6S管理：整理、整顿、清扫、清洁、素养、安全</div>
            <div class="content1">
                <div class="img1 wow animate__animated animate__zoomInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/sixs/01.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__zoomInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/sixs/02.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__zoomInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/sixs/03.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__zoomInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/sixs/04.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__zoomInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/dxal/hd-a5.png" alt="">
                </div>
                <div class="img1 wow animate__animated animate__zoomInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/dxal/hd-a6.png" alt="">
                </div>
                <div class="img1 wow animate__animated animate__zoomInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/sixs/05.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__zoomInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/sixs/06.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__zoomInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/sixs/07.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__zoomInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/sixs/08.jpg" alt="">
                </div>
            </div>
        </div> -->
        <div class="section wow animate__animated animate__fadeInUp" data-wow-duration="1s" >
        <div class="section-title">6S管理：整理、整顿、清扫、清洁、素养、安全</div>
        <div class="dual-card" >
            <div class="gallery-img wow animate__animated animate__fadeInLeft" data-wow-delay="0.2s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-14-43-09-17301.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.2s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-14-43-20-12602.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInLeft" data-wow-delay="0.3s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-14-43-31-45603.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.3s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-14-43-41-18004.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInLeft" data-wow-delay="0.4s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-14-44-09-498hd-a5.png" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.4s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-14-44-24-226hd-a6.png" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInLeft" data-wow-delay="0.5s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-14-44-34-72305.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.5s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-14-44-44-74606.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInLeft" data-wow-delay="0.6s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-14-44-55-36007.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.6s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-14-45-05-85008.jpg" alt="">
            </div>
        </div>
        <div class="section-footer-text">
            旨在通过规范化的现场管理，消除浪费、提升效率、保障安全，塑造整洁有序的工作环境与员工良好素养。
        </div>
    </div>
    </div>
</template>

<script>
import Swiper from "swiper";
import { WOW } from 'wowjs'
export default {
    mounted() {
    //第一种写法，可以设置wow中属性
    this.$nextTick(() => { // 在dom渲染完后,再执行动画
    var wow = new WOW({
        boxClass: 'wow',///动画元件css类（默认为wow）
        animateClass: 'animated',//动画css类（默认为animated） 
        offset: 0,//到元素距离触发动画（当默认为0） 
        mobile: true, //在移动设备上触发动画（默认为true） 
        live: true//对异步加载的内容进行操作（默认为true）
    })
    wow.init()
    }),
    new Swiper(".banner",{
        loop:true, //循环模式选项

        // 如果需要分页器
        pagination:{
            el:".swiper-pagination",
        },
        // 如果需要前进后退按钮
        navigation:{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        // 如果需要滚动条
    //   scrollbar: {
    //     el: ".swiper-scrollbar",
    //   },

      autoplay: {
        autoplay: true, // 自动切换
        disableOnInteraction: false, // 点击之后重新计算
      },
    });
},
}
</script>

<style scoped>
.banner{
    width: 100%;
    height: 3.5rem;
    overflow: hidden;
}
/* .banner:hover img{
    transform: scale(1.2);
} */
.banner img{
    /* transition: all .4s; */
    width: 100%;
    height: 100%;
    /* display: block;
    object-fit: cover; */
}
.main1,
.main2{
    width: 100%;
    /* height: 3rem; */
    background-color: #ededed;
    /* margin: 20px auto; */
}
.title1{
    font-size: .1rem;
    font-weight: 700;
    padding: 20px 0;
}
.content1{
    width: 70%;
    /* height: 2.66rem; */
    margin: 0 auto;
    display: flex;
    /* background-color: green; */
    flex-wrap: wrap;
}
.img1,.img2{
    width: 50%;
    height: 375px;
}
img{
    width: 100%;
    height: 100%;
}
.text1{
    width: 50%;
    /* height: 2.66rem; */
    /* background-color: yellow; */
}

.section {
            /* max-width: 1280px;
            margin: 0 auto;
            padding: 60px 24px; */

                padding: 0.3125rem 0.125rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
        }
        .section-title {
            text-align: center;
            font-size: 30px;
            font-weight: 700;
            margin-bottom: 48px;
            position: relative;
            letter-spacing: 2px;
        }
        .section-title:after {
            content: '';
            display: block;
            width: 80px;
            height: 4px;
            background: linear-gradient(90deg, #f97316, #facc15);
            margin: 16px auto 0;
            border-radius: 4px;
        }
        /* 网格布局（左右交替卡片） */
        .gallery-grid {
            display: flex;
            flex-direction: column;
            gap: 48px;
        }
        .gallery-row {
            display: flex;
            gap: 30px;
            align-items: center;
            background: #ffffff;
            border-radius: 32px;
            box-shadow: 0 20px 35px -12px rgba(0,0,0,0.1);
            overflow: hidden;
            transition: all 0.3s;
        }
        .gallery-row:hover {
            transform: translateY(-6px);
            box-shadow: 0 25px 40px -12px rgba(0,0,0,0.15);
        }
        .gallery-img {
            flex: 1;
            overflow: hidden;
            max-height: 350px;
        }
        .gallery-img img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.6s cubic-bezier(0.2, 0.9, 0.4, 1.1);
            display: block;
        }
        .gallery-row:hover .gallery-img img {
            transform: scale(1.05);
        }
        .gallery-desc {
            flex: 1;
            padding: 24px 32px;
        }
        .gallery-desc h3 {
            font-size: 24px;
            margin-bottom: 12px;
            color: #f97316;
        }
        .gallery-desc p {
            font-size: 16px;
            color: #475569;
            line-height: 1.6;
        }
        /* 交替方向 */
        .gallery-row.reverse {
            flex-direction: row-reverse;
        }
        /* 员工体检双卡片 */
        .dual-card {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 30px;
        }
        .dual-card .gallery-img {
            max-height: 380px;
            border-radius: 24px;
            overflow: hidden;
            box-shadow: 0 15px 25px -8px rgba(0,0,0,0.1);
        }
        .dual-card .gallery-img img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.4s;
        }
        .dual-card .gallery-img:hover img {
            transform: scale(1.03);
        }
        .section-footer-text {
            text-align: center;
            margin-top: 32px;
            color: #475569;
            font-size: 18px;
            padding: 0 20px;
        }
</style>